import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ObjectValues } from 'helpers/types';

import { ExpensesAssumptions } from './ExpensesAssumptions';
import { SalesAssumptions } from './SalesAssumptions';

export const KEY_ASSUMPTIONS_NAMES = {
  SALES_ASSUMPTIONS: 'salesAssumptions',
  EXPENSES_ASSUMPTIONS: 'expensesAssumptions',
} as const;

export type IKeyAssumptionsValuesType = ObjectValues<typeof KEY_ASSUMPTIONS_NAMES>;

export const useGetKeyAssumptionsOptions = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const KEY_ASSUMPTIONS_OPTIONS = [
      {
        label: t('pdfPages.mappings.financialPlan.salesAssumptionsSmall'),
        value: KEY_ASSUMPTIONS_NAMES.SALES_ASSUMPTIONS,
      },
      {
        label: t('pdfPages.mappings.financialPlan.expensesAssumptionsSmall'),
        value: KEY_ASSUMPTIONS_NAMES.EXPENSES_ASSUMPTIONS,
      },
    ];
    return KEY_ASSUMPTIONS_OPTIONS;
  }, [t, i18n]);
};

export const keyAssumptionsToComponentMap: Record<IKeyAssumptionsValuesType, FC<{ disabled: boolean }>> = {
  [KEY_ASSUMPTIONS_NAMES.SALES_ASSUMPTIONS]: SalesAssumptions,
  [KEY_ASSUMPTIONS_NAMES.EXPENSES_ASSUMPTIONS]: ExpensesAssumptions,
};
